import { ElementProperties, Checkbox, Details, Div, H2, A, Header, Span, Summary, all, VBoolean, Button } from 'alkali'
import AnnotatableText, { AnnotatableTextOpts } from 'components/extract/AnnotatableText'
import ExtractAnnotationModel from 'components/extract/ExtractAnnotationModel'
import * as _ from 'lodash'
import Icon from 'components/Icon'
import * as edit from 'icons/pencil-write-2.svg'
import VAbstractSource from 'components/extract/model/AbstractSource'
import studyUrls from 'components/studies/studyUrls'
import app from 'app/app'
import * as OpenBookIcon from 'icons/book-open-text.svg'


interface AbstractTextOps extends AnnotatableTextOpts {
	model: ExtractAnnotationModel
}

const ABSTRACT_FONT_SIZES = [[2000, 'default'], [2500, 'smaller'], [Infinity, 'smallest']]

const abstractFontClass = len => 'text-' + _.find(ABSTRACT_FONT_SIZES, ([l]) => len <= l)[1]

/**
 * Annotatable abstract text with annotations from abstract
 */
class AbstractText extends AnnotatableText.with('.study-abstract.annotations.dre-ds-ann') {
	created(props: AbstractTextOps) {
		props.text = props.model.abstract.property('text')
		props.annotations = props.model.annotatedAbstract.to(a => a.visibleAnnotations).whileResolving(props.model.abstract.property('labels'))
		// @ts-ignore
		super.created(props)
		const model = props.model
		const focused = props.model.focusedState.property('focused')
		props.class = all([focused, props.text], (focused, text) => `${props.className} ${focused || ''} ${abstractFontClass(text.length)}`)
		props.classes = {
			highlighting: model.selecting(),
		}
	}
}

interface AnnotateAbstractOpts extends ElementProperties<AnnotateAbstract> {
	model: ExtractAnnotationModel
	abstractSource: VAbstractSource
	study: any
	edit: VBoolean
	allToggle: VBoolean
	debug?: boolean
}

/**
 * Interactive annotated abstract
 */
export default class AnnotateAbstract extends Div('.view-abstract') {
	created(props: AnnotateAbstractOpts) {
		const { abstractSource, model } = props
		const urls = studyUrls(props.study, app.user)
		props.content = [
			Header([
				H2([
					Span(abstractSource.property('Title')),
					!props.study
						? Icon('.clickable.float-right', {
								icon: edit,
								title: 'Edit abstract',
								onclick() {
									props.edit.put(!props.edit.valueOf())
								},
						  })
						: undefined,
				]),
				Div([
				...urls.map((entry) =>
					A('.src-link', { href: entry.url, target: '_blank', rel: 'noopener' }, [
						Button(
							'.src-btn',
							{
								title: `${entry.source}: ${entry.url}`,
							},
							[Span(entry.source), Icon('.clickable', { icon: OpenBookIcon })]
						),
					])
					)
				]),
			]),
			...(props.debug
				? [
						Details([
							Summary('Debug'),
							Div([Span('Toggle DocSeach annotations'), Checkbox(props.allToggle)]),
						]),
				  ]
				: []),
			new AbstractText({
				model,
			}),
		]
	}
}